import React, { Component } from 'react'
import '../styles/SiteCreation.css'
import OrgFooter from '../widgets/OrgFooter'
import DropdownWidget from '../widgets/DropdownWidget'
import APIGenericRequest from '../api/APIGenericRequest'
import APISiteRequest from '../api/APISiteRequest'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'

class SiteCreation extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			region: "-- SELECT --",
			province: "-- SELECT --",
			roleId: user.role_id,
			city: "-- SELECT --",
			yearLauncued: "-- SELECT --",
			showInfoMessage: false,
			disabled: (props.view === "view-details")? true: false,
			disableSubmit: false
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.getSiteById = this.getSiteById.bind(this)
		this.getAllRegions = this.getAllRegions.bind(this)
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this)
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
	}

	componentWillMount() {
		if(this.state.roleId === 6) {
			this.getAllRegions()
		}
		this.getAllCitiesByProvinceId()
		if(this.props.view != null) {
			this.getSiteById()
		}
	}

	getSiteById() {
		this.setState({showActivityIndicator: true})
		const site = APISiteRequest.getSiteById(this.state.accessToken, this.props.id)
		site.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			let ds = true
			if(this.props.view === "update") {
				ds = false
			}
			this.setState({
				siteName: response.results.name,
				region: response.results.region,
				province: response.results.province,
				city: response.results.city,
				yearLauncued: response.results.year_started,
				approvalDate: response.results.approval_date,
				congressionalDistrict: response.results.congressional_district,
				disableSubmit: ds,
				showActivityIndicator: false
			})
		})
	}

	getAllRegions() {
		const region = APIGenericRequest.getAllRegions(this.state.accessToken)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push(v.name.split("[")[0])
				var rows = response.results.rows
			}
			c.sort()
			const regions = []
			regions.push({id: 0, name: "-- SELECT --"})
			for(const re of c) {
				for(const ro of rows) {
					if(ro.name.includes(re)) {
						regions.push({id: ro.region_id, name: ro.name.split("[")[0]})
						const index = rows.indexOf(ro)
						rows.splice(index, 1)
					}
				}
			}
			this.setState({regions: regions})
		})
	}

	getAllProvincesByRegionId(id) {
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			this.setState({
				provinces: c,
				province: "-- SELECT --",
				city: "-- SELECT --",
			})
		})
	}

	getAllCitiesByProvinceId(id) {
		const city = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name})
			}
			this.setState({
				cities: c,
				city: "-- SELECT --"
			})
		})
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const data = {
			"name": this.state.siteName,
			"region_id": this.state.regionId,
			"province_id": this.state.provinceId,
			"city_id": this.state.cityId,
			approval_date: this.state.approvalDate,
			year_started: this.state.year,
			congressional_district: this.state.congressionalDistrict
		}
		if(this.props.view === "update") {
			const site = APISiteRequest.editSite(this.state.accessToken, data, this.props.id)
			site.then((response) => {
				if(response.status === "FAILED") {
					this.setState({showActivityIndicator: false})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: "Site " + this.state.siteName + " successfully updated.",
					showActivityIndicator: false
				})
			})
		}
		else {
			const site = APISiteRequest.addSite(this.state.accessToken, data)
			site.then((response) => {
				if(response.status === "FAILED") {
					this.setState({showActivityIndicator: false})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: "Site " + this.state.siteName + " successfully added.",
					showActivityIndicator: false
				})
			})
		}
	}

	render() {
		const view = <div id="site-creation">
			<div className="title-bar">SITE PROFILE</div>
			<div id="sc-cell">
				<div id="sc-location">
					<div id="sc-cell-i2">
						<div style={{'margin-bottom': '5px'}}>Region</div>
						<DropdownWidget list={this.state.regions} placeholder={this.state.region}
							onItemSelected={(id, val) => {
								this.setState({regionId: id, region: val})
								this.getAllProvincesByRegionId(id)
							}}  cStyle={{"width": "100%"}} disabled={this.state.disabled} />
					</div>
					<div id="sc-cell-i3">
						<div style={{'margin-bottom': '5px'}}>Province</div>
						<DropdownWidget list={this.state.provinces} placeholder={this.state.province}
							onItemSelected={(id, val) => {
								this.setState({provinceId: id, province: val})
								this.getAllCitiesByProvinceId(id)
							}}  cStyle={{"width": "100%"}} disabled={this.state.disabled} />
					</div>
					<div id="sc-cell-i4">
						<div style={{'margin-bottom': '5px'}}>Municipality</div>
						<DropdownWidget list={this.state.cities} placeholder={this.state.city}
							onItemSelected={(id, val) => {
								this.setState({cityId: id, city: val, siteName: val})
							}}  cStyle={{"width": "100%"}} disabled={this.state.disabled} />
					</div>
					<div id="sc-cell-i5">
						<div>Congressional/Legislative District</div>
						<input type="text" value={this.state.congressionalDistrict} onChange={(e) => {
							this.setState({congressionalDistrict: e.target.value})
						}} disabled={this.state.disabled} />
					</div>
				</div>
				<div id="sc-cell-row1">
					<div id="sc-row1-i1">
						<div>Site Name</div>
						<input type="text" value={this.state.siteName} onChange={(e) => {
							this.setState({siteName: e.target.value})
						}} disabled={this.state.disabled} />
					</div>
					<div id="sc-row1-i2">
						<div>Approval Date</div>
						<DatePicker value={this.state.approvalDate} onChange={(value) => {
							this.setState({approvalDate: value})
						}} disabled={this.state.disabled} />
					</div>
					<div id="sc-row1-i3">
						<div style={{'margin-bottom': '5px'}}>Year Launched</div>
						<DropdownWidget list={yearList()} placeholder={this.state.yearLauncued}
							onItemSelected={(id, val) => {
								this.setState({year: val})
								this.getAllCitiesByProvinceId(id)
							}}  cStyle={{"width": "100%"}} disabled={this.state.disabled} />
					</div>
				</div>
			</div>
			<div id="sc-footer"><OrgFooter submit={this.onSubmit} disabled={this.state.disableSubmit} showSubmit={true} /></div>
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
					this.props.onSignal("sites")
				}}/>}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

const yearList = () => {
	const date = new Date();
	const years = []
	years.push({name: "-- SELECT --"})
	for(let i=0; i<=20; i++) {
		years.push({name: date.getFullYear() - i})
	}
	return(years)
}

export default SiteCreation
